module.exports = __webpack_public_path__ + "static/media/OrdersIconBlack.b31adaeb.svg";